module.exports = __webpack_public_path__ + "img/chokorin.3302367c.png";